import { removeProductsFromOrder } from '@app/ducks';
import { useConfirmationGuard } from '@app/utils/hooks';
import { Order } from '@typings';
import { uniq } from 'ramda';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export const useRemoveSelectionProducts = (orderProducts: Order.Product[] = []) => {
  const { t } = useTranslation(['cancelled', 'confirmationConfig']);
  const dispatch = useDispatch();
  const confirmationGuard = useConfirmationGuard();

  const deliveryWindows = uniq(orderProducts.map(product => product.deliveryWindow));

  return confirmationGuard(() => ({
    content: t('confirmationConfig:remove_unavailable_variants_from_order.content', { count: orderProducts.length, returnObjects: false }),
    onOk: () => {
      dispatch(
        removeProductsFromOrder({
          deliveryWindows,
          products: uniq(orderProducts.map(product => product.product)),
          variants: uniq(orderProducts.map(product => product.variant)),
        }),
      );
    },
    title: t('confirmationConfig:remove_unavailable_variants_from_order.title', { count: orderProducts.length, returnObjects: false }),
  }));
};
